var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tavern-recruits-page"},[_c('mobile-nav-bar',_vm._b({ref:"mobile-nav-bar",attrs:{"text":("#" + (_vm.$route.params.tavernId) + " recruits")},on:{"history":_vm.tCloseHandle}},'mobile-nav-bar',_vm.scrollOpt,false)),_vm._v(" "),_c('mobile-tavern-recruits')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c43a8ed","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/_mobile/_recruits.vue
// module id = null
// module chunks = 